import { RolesPermissionsMap } from "../entities/roles-permissions-map";
import { RolesPermissionsRepositoryInterface } from "./roles-permissions-repository-interface";

export class RolesPermissionsFileRepository
  implements RolesPermissionsRepositoryInterface
{
  private rolesPermissionsMap: RolesPermissionsMap;

  constructor(rolesPermissionsMap: RolesPermissionsMap = {}) {
    this.rolesPermissionsMap = rolesPermissionsMap;
  }

  public setRolesPermissions(rolesPermissionsMap: RolesPermissionsMap) {
    this.rolesPermissionsMap = rolesPermissionsMap;
  }

  public getRolesPermissions(): RolesPermissionsMap {
    return this.rolesPermissionsMap;
  }

  public getPermissionsForRoles(roles: string[]): Set<string> {
    const permissions = roles.flatMap(
      (role) => this.rolesPermissionsMap[role] ?? [],
    );
    return new Set(permissions);
  }
}
